import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { ref } from 'vue';
import Input from '@/components/ui/input/Input.vue';
import { Eye, EyeOffIcon } from 'lucide-vue-next';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: /*#__PURE__*/_mergeModels({
  placeholder: {
    type: String,
    required: false,
    default: undefined
  }
}, {
    "modelValue": {
  type: String,
  required: false,
  default: undefined
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const model = _useModel<string | undefined>(__props, "modelValue");


const isPasswordVisible = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isPasswordVisible.value)
      ? (_openBlock(), _createBlock(_unref(EyeOffIcon), {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isPasswordVisible.value = !isPasswordVisible.value)),
          class: "absolute right-2 top-3 size-4 text-slate-500"
        }))
      : (_openBlock(), _createBlock(_unref(Eye), {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isPasswordVisible.value = !isPasswordVisible.value)),
          class: "absolute right-2 top-3 size-4 text-slate-500"
        })),
    _createVNode(Input, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
      type: isPasswordVisible.value ? 'text' : 'password',
      placeholder: __props.placeholder
    }, null, 8, ["modelValue", "type", "placeholder"])
  ]))
}
}

})